export default __webpack_public_path__ + "static/media/Background_00096.ac135ac6.png";